function isIpAddress(host: string): boolean {
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
}

export function getCurrentSubdomain(): string | null {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname;
  const hostnameWithoutPort = hostname.split(':')[0];
  const parts = hostnameWithoutPort.split('.');

  // IP addresses look like multi-part domains — skip subdomain extraction
  if (!isIpAddress(hostnameWithoutPort)) {
    if (parts.length >= 2 && parts[parts.length - 1] === 'localhost') {
      return parts[0] !== 'localhost' ? parts[0] : null;
    }
    if (parts.length >= 3) return parts[0];
  }

  const urlParams = new URLSearchParams(window.location.search);
  const querySubdomain = urlParams.get('subdomain');
  if (querySubdomain) {
    localStorage.setItem('staffSubdomain', querySubdomain);
    return querySubdomain;
  }
  return localStorage.getItem('staffSubdomain');
}
